import type { ConversationMessage } from '../../store/converse/types';

export const getTotalRequestForms = (message: ConversationMessage): number => {
    return message?.appendices?.filter((appendix) => appendix.type === 'requestForm')?.length ?? 0;
};
